export const INITIALISE_APP = "INITIALISE_APP";

export function initialiseApp() {
    return {type: INITIALISE_APP }
}
